import { useParams } from 'react-router-dom';
import keys from './keys';
import useApiQuery from '../useApiQuery';

const useGetSupportersInfo = ({ showId: showIdParam, disabled } = {}) => {
  const { showId: currentShowId } = useParams();
  const showId = showIdParam || currentShowId;

  const query = useApiQuery({
    queryKey: keys(showId).supporters,
    requestUrl: `/shows/${showId}/supporters`,
    disabled: !showId || disabled,
  });

  return {
    supporterInfo: query.data,
    supporterInfoError: query.error,
    isSupporterInfoFetchError: query.isError,
    isSupporterInfoFetchSuccess: query.isSuccess,
    isSupporterInfoFetching: query.isFetching,
    isSupporterInfoLoading: query.isInitialLoading,
    ...query,
  };
};

export default useGetSupportersInfo;
